<template lang="pug">
  .notification
    .notification__header
      .notification__title Новый заказ № {{ payload.orderNumber }}
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        | {{ payload.constructorType }} шкаф
        | {{ payload.width }}x{{ payload.height }}x{{ payload.depth }}
        | ({{ payload.clientName }})
      router-link.notification__link(
        @click.native="emitClick"
        title="Посмотреть заказ"
        :to="{name: 'orders.order', params: { orderId: payload.orderId }}"
      ) Перейти на страницу заказа
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'OrderReceived',
  mixins: [notification]
};
</script>
